import { fetchUserFiles } from '../api/digitalVault';
export default async (params = {}, album, logger) => fetchUserFiles(params, `browse/audio/album/${encodeURIComponent(album)}`, logger);
